module.exports = __webpack_public_path__ + "assets/img/my.4fa760b8.png";